export enum InvitationTypes {
  CHILD = 'child',
  PARENT = 'parent',
  COACH = 'coach',
  PLAYER = 'player'
}
